/* eslint-disable */
import React, { useEffect } from 'react';
import DataList from '../../sharedcomponents/dataList/dataList';
import { useState, Downgraded } from '@hookstate/core';
import { Paper, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import Helper from '../../utility/helper';
import { useAuthState } from '../../stores/authStore';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import {
    NO_ACCESS_PERMISSION,
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import SendEmail from '../../modules/Invitation/sendEmail';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    cardContent: {
        '&:last-child': {
            paddingBottom: '16px',
        },
    },
}));
const SentInvitationList = (props) => {
    const loading = useState(false);
    const classes = useStyles();
    const invitationList = useState([]);
    const users = useState([]);
    const authState = useAuthState();
    const eventData = useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const openSendEmail = useState(false);
    const invitationInfo = useState(null);
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const userID = useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            userID.set(userInfo.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() => {
        if (
            props.modPermission &&
            props.modPermission != NO_ACCESS_PERMISSION
        ) {
            if (props.data && props.data.length > 0) {
                loadData(props.data);
            }
            else
                getInvitationList();

        }
    }, [props.modPermission]);

    const loadData = (data) => {
        let usersData = [];
        if (data.length > 0) {
            data.map((item) => {
                if (item.status === 1 || item.status === 2) {
                    usersData.push({
                        actualData: item,
                        row: [
                            {
                                label: 'checkbox',
                                key: 'invitationID',
                                invitationID: item.invitationID,
                                width: '0.05',
                            },
                            {
                                label: 'Name',
                                key: 'participant',
                                participant: item.participant,
                                showLabel: false,
                                width: '0.30',
                                inColumn: true,
                                showEmail: true,
                                toEmail: item.emailID === 'null' ? null : item.emailID,
                            },
                            {
                                label: 'cc',
                                key: 'ccEmailID',
                                ccEmailID: item.ccEmailID,
                                width: '0.22',
                                inColumn: true,
                                showTooltip: true,
                                wrapAll: true,
                            },
                            {
                                label: 'bcc',
                                key: 'bccEmailID',
                                bccEmailID: item.bccEmailID,
                                width: '0.22',
                                inColumn: true,
                                showTooltip: true,
                                wrapAll: true,
                            },
                            {
                                label: 'Status',
                                key: 'status',
                                status:
                                    item.status == 0
                                        ? 'Pending'
                                        : 'Sent' +
                                        ' On ' +
                                        Helper.FormatDate(
                                            item.sentDateTime
                                        ) +
                                        ' @ ' +
                                        Helper.FormatTime(
                                            item.sentDateTime
                                        ),
                                width: '0.23',
                                inColumn: true,
                                isSent: true,
                            },
                            {
                                label: 'Attachment',
                                key: 'attachments',
                                showLabel: false,
                                width: '0.02',
                                showAttachmentIcon:
                                    item.attachments.length > 0
                                        ? true
                                        : false,
                            },
                            {
                                label: 'ArchiveMail',
                                key: 'archiveMail',
                                showLabel: false,
                                width: '0.02',
                                disableIcon: item.status === 2 ? true : false,
                            },
                            {
                                label: 'SenMail',
                                key: 'sendMail',
                                showLabel: false,
                                width: '0.02',
                                showViewIcon: true,
                            },
                            { showChips: true },
                        ],

                        selected: false,
                    });
                }
            });

        }
        usersData = usersData.sort((a, b) => (new Date(b.actualData.sentDateTime) - new Date(a.actualData.sentDateTime)));
        invitationList.set(usersData);
        users.set(usersData);
    }

    const getInvitationList = () => {
        loading.set(true);

        return ApiHelper.get(
            APIURLConstants.GET_INVITATION_LIST(
                eventData.get().eventID,
                1,
                5000
            )
        )
            .then((res) => {
                let data = res.data.invitations;

                loadData(data);
                loading.set(false);
                return usersData;
            }).catch((err) => {
                console.log(err);
                loading.set(false);
            });

    };
    const editSendEmail = (info) => {
        openSendEmail.set(true);
        invitationInfo.set(info.actualData);
        // return ApiHelper.get(
        //     APIURLConstants.EditInvitation(
        //         info.actualData.invitationID
        //     )
        // )
        //     .then((res) =>
        //     {
        //         let data = res.data.invitations;
        //         invitationInfo.set(data[0]);
        //         openSendEmail.set(true);
        //     })
    };
    const closeSendEmail = () => {
        openSendEmail.set(false);
    };
    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getInvitationList();
    };

    const archiveMail = (item) => {
        const obj = {
            Ids: item.actualData.invitationID.toString(),
            ModifiedBy: userID.get()
        }

        archiveInvitation(obj);
    }

    const archiveInvitation = (obj) => {
        ApiHelper.post(APIURLConstants.ARCHIVE_INVITATION_EMAIL, obj)
            .then((res) => {
                if (res.data) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Invitation archived successfully',
                    });
                    let data = [...invitationList.get()];
                    let arrayIds = obj.Ids.split(',');
                    data.forEach(i => {
                        if (arrayIds.includes(i.actualData.invitationID.toString())) {
                            i.actualData.status = 2;
                            i.selected = false;

                            i.row.forEach(row => {
                                if (row.label === 'ArchiveMail') {
                                    row.disableIcon = true
                                }
                            })
                        }
                    });
                    invitationList.set(data);
                    users.set(data);
                }
                else {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong',
                    });
                }
            }).catch(err => {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong',
                });
            });
    }

    const archiveAllRows = () => {
        const selected = invitationList
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Invitation first',
            });
        } else {
            let arrIds = [];
            selected.forEach(i => {
                arrIds.push(i.actualData.invitationID)
            })
            const obj = {
                Ids: arrIds.join(','),
                ModifiedBy: userID.get()
            }
            archiveInvitation(obj);
        }

    };

    return (
        <>
            {loading.get() ? (
                <Box
                    sx={
                        loading.get()
                            ? { paddingTop: '20%', paddingBottom: '20%' }
                            : ''
                    }
                    className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : props.modPermission &&
                props.modPermission == NO_ACCESS_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none' }}>
                    {invitationList.get() ? (
                        <DataList
                            data={invitationList.attach(Downgraded).get()}
                            title={''}
                            editSendEmail={editSendEmail}
                            hideAdd={true}
                            hideDelete={true}
                            showSearch={true}
                            invitationPage
                            //showEdit={false}
                            showArchive
                            searchLabel={'Search'}
                            pagingInfo={pagingInfo.attach(Downgraded).get()}
                            handlePageChange={handlePageChange}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            modPermission={props.modPermission}
                            archiveMail={archiveMail}
                            archiveAllRows={archiveAllRows}
                        />
                    ) : null}
                </Paper>
            )}
            {openSendEmail.get() && (
                <SendEmail
                    open={openSendEmail.get()}
                    invitationInfo={invitationInfo
                        .attach(Downgraded)
                        .get()}
                    title="Send Email"
                    handleClose={closeSendEmail}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    getInvitationList={getInvitationList}
                    view={true}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </>
    );
};
export default SentInvitationList;
